var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/small 12px Copy 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-a-kit_Insights_Youtube_Video-Content",
    transform: "translate(-40.000000, -1320.000000)",
    stroke: "#111111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module/overall-",
    transform: "translate(20.000000, 1007.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Insights/Engagement",
    transform: "translate(20.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tap-02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.646,8 C1.13626156,6.31150077 1.11681365,3.76402464 2.60059698,2.0526723 C4.08438032,0.341319956 6.60889754,-0.000477664449 8.49432493,1.25471292 C10.3797523,2.50990351 11.0383995,4.97083763 10.032,7",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,10.5 C1.3954305,10.5 0.5,11.3954305 0.5,12.5 L0.5,13.5 C0.5,14.6045695 1.3954305,15.5 2.5,15.5 L13.5,15.5 L14.718,11.847 C14.9089227,11.2739618 14.8306481,10.6453341 14.5050284,10.136614 C14.1794088,9.627894 13.6413262,9.29357846 13.041,9.227 L7.5,8.611 L7.5,5 C7.5,4.17157288 6.82842712,3.5 6,3.5 C5.17157288,3.5 4.5,4.17157288 4.5,5 L4.5,12.5",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.3517a3f5a150f20c481b418971533b9c.svg";
export { ForwardRef as ReactComponent };